
module.exports = {
  cofiguration: {
    appId: '1d20239c-928c-486e-9cbc-6ad2f89d796b',
    redirectUri: 'http://localhost:3000',
    tenant: '9b995efe-255d-496c-b7bf-efc3ae8d8192',
    scopes: [
      'user.read',
      'calendars.read'
    ],
    authority: "https://login.microsoftonline.com/9b995efe-255d-496c-b7bf-efc3ae8d8192"
  }
}